import React, { useEffect, useState } from 'react';
import {
  StyledAccordionButton,
  StyledAccordionContentContainer,
  StyledAccordionContentText,
  StyledAccordionItem,
  StyledAccordionItemSeparator,
} from './Accordion.styles';
import { AccordionItemProps } from './Accordion.consts';
import { StyledRowOffset } from '@/shared/styles';
import { processTextContent } from '@/shared/pages/Policies/PolicySection/PolicySection.utils';
import { CaretDown } from '../Caret/CaretDown';
import { CaretUp } from '../Caret/CaretUp';

export const AccordionItem: React.FC<AccordionItemProps> = ({
  showDescription,
  item,
  onClick,
  largeContent,
}) => {
  const [isContentVisible, setIsContentVisible] = useState(!largeContent);

  useEffect(() => {
    if (largeContent) {
      if (showDescription) {
        setIsContentVisible(true);
      } else {
        const timeout = setTimeout(() => setIsContentVisible(false), 400);
        return () => clearTimeout(timeout);
      }
    }
  }, [showDescription]);

  return (
    <StyledAccordionItem className={`accordion-item ${showDescription ? 'item-visible' : ''}`}>
      <StyledRowOffset $gap={12}>
        {item.additionalItem && item.additionalItem}
        <StyledAccordionButton
          data-u1-accordion="header"
          showDescription={showDescription}
          onClick={onClick}
        >
          {item.title}
          {showDescription ? <CaretUp /> : <CaretDown />}
        </StyledAccordionButton>
      </StyledRowOffset>
      {isContentVisible && (
        <StyledAccordionContentContainer
          data-u1-accordion="content"
          showDescription={showDescription}
        >
          {item.content && (
            <StyledAccordionContentText>
              {processTextContent(item.content)}
            </StyledAccordionContentText>
          )}
          {item.customContent && item.customContent}
        </StyledAccordionContentContainer>
      )}
      <StyledAccordionItemSeparator className="accordion-item-separator" />
    </StyledAccordionItem>
  );
};
